export const viewingRoomRoutes = {
  path: "/viewing-room/:viewingRoomId",
  link: (viewingRoomId: string | number) => `/viewing-room/${viewingRoomId}`,
};
